package com.sddamico.draftmachine.ds.overlays

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.ds.DmMotion
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.dmPanel
import com.sddamico.draftmachine.ds.motion.LocalExiting
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

/**
 * A phone-width steel panel over a dimmed screen — the shell of the draft room's pick dialogs and
 * the wizard's CSV import. Tapping the scrim calls [onDismiss]. Rises in on open; inside a
 * [Presence][com.sddamico.draftmachine.ds.motion.Presence] it sinks away on close.
 *
 * @param labelledBy id of the element holding the dialog's title.
 */
@Composable
fun PanelDialog(
  labelledBy: String,
  onDismiss: () -> Unit,
  content: @Composable () -> Unit,
) {
  val exiting = LocalExiting.current
  val exitMs = "${DmMotion.overlayExitMs}ms"
  Div(
    attrs = Modifier.position(Position.Fixed).zIndex(1000).displayFlex()
      .alignItems(AlignItems.Center).justifyContent(JustifyContent.Center)
      .padding(20.px)
      .styleModifier {
        property("inset", "0")
        if (exiting) property("pointer-events", "none")
      }
      .toAttrs {
        attr("role", "dialog")
        attr("aria-modal", "true")
        attr("aria-labelledby", labelledBy)
      },
  ) {
    Div(
      attrs = Modifier.position(Position.Absolute).backgroundColor(Color.rgba(13, 16, 19, 0.72f))
        .styleModifier {
          property("inset", "0")
          property(
            "animation",
            if (exiting) "dm-fade-out $exitMs ${DmMotion.easeOut} both"
            else "dm-fade-in ${DmMotion.durBase} ${DmMotion.easeOut} both",
          )
        }
        .toAttrs { onClick { onDismiss() } },
    ) {}
    Div(
      attrs = Modifier.position(Position.Relative).zIndex(1).fillMaxWidth().maxWidth(390.px)
        .dmPanel().padding(20.px).displayFlex().flexDirection(FlexDirection.Column).gap(14.px)
        .styleModifier {
          property(
            "animation",
            if (exiting) "dm-dialog-out $exitMs ${DmMotion.easeExit} both"
            else "dm-dialog-in ${DmMotion.pageEnterMs}ms ${DmMotion.easeSnap} both",
          )
        }
        .toAttrs(),
    ) {
      content()
    }
  }
}
